<div class="onboarding-card-title" translate
    [translateParams]="{ language: selectedLanguageName }">
    ai-exam-onboarding.perception-gauges.title
</div>
<p class="onboarding-card-subtitle" translate>ai-exam-onboarding.perception-gauges.subtitle</p>

<div class="gauges-grid">
    <div class="gauge-legend">
        <!-- <div class="gauge-legend-track">
            <div class="gauge-legend-fill"></div>
        </div> -->
        <div class="gauge-legend-labels text-black">
            <span class="gauge-legend-label" translate>ai-exam-onboarding.perception-gauges.level.beginner</span>
            <span class="gauge-legend-label" translate>ai-exam-onboarding.perception-gauges.level.intermediate</span>
            <span class="gauge-legend-label" translate>ai-exam-onboarding.perception-gauges.level.advanced</span>
        </div>
    </div>

<div class="skill-rows">
    @for (skill of skills; track skill.id) {
    <div class="skill-row">
        <div class="skill-info">
            <div class="skill-label">
                <span class="skill-icon" aria-hidden="true">{{ skillIcon(skill.id) }}</span>
                <span translate>{{ skillLabelKey(skill.id) }}</span>
            </div>
        </div>
        <div class="gauge-track" (click)="onTrackClick(skill.id, $event)">
            <div class="gauge-fill" [style.width]="getFillWidth(skill.id)"></div>
            <div class="gauge-handle" [style.left]="getHandleLeft(skill.id)"></div>
        </div>
        <!-- <div class="gauge-labels">
            @for (level of [1, 2, 3]; track level) {
            <span class="gauge-label-item" [class.active]="isLabelActive(skill.id, level)"
                (click)="setLevel(skill.id, level)">
                <span translate>{{ descriptionKey(skill.id, level) }}</span>
            </span>
            }
        </div> -->
    </div>
    }
</div>
</div>

<div class="onboarding-actions">
    <button type="button" class="onboarding-btn-back" (click)="back.emit()">
        ← <span translate>ai-exam-onboarding.back</span>
    </button>
    <button type="button" class="onboarding-btn-primary flex-1" (click)="continue.emit()">
        <span translate>ai-exam-onboarding.continue</span>
    </button>
</div>
